import React from "react";
import { Row, Col, Card } from "antd";
import { useGetConsultantChartsQuery } from "../../../Redux/service/Consultant/ConsultantDashboard";
import Loader from "../../Helpers/Loader/Loader";
import trans from "../../../utils";
import BarChart from "../../DashboardDraggable/Charts/BarChart";
import PieChart from "../../DashboardDraggable/Charts/PieChart";

export default function ConsultantCharts({ refreshKey }) {
  const { data: chartsData, isLoading } = useGetConsultantChartsQuery(
    { refreshKey },
    { refetchOnMountOrArgChange: true }
  );

  if (isLoading) {
    return <Loader />;
  }

  // Extract bar chart data
  const barChartData = chartsData?.barChart?.data || [];
  const barChartLabels = chartsData?.barChart?.labels || [];

  // Extract pie chart data
  const pieChartData = chartsData?.pieChart?.data || [];
  const pieChartLabels = chartsData?.pieChart?.labels || [];
  const pieChartColors = chartsData?.pieChart?.colors || [
    "#023E8A",
    "#0077B6",
    "#0096C7",
    "#00B4D8",
    "#48CAE4",
    "#90E0EF",
  ];

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} lg={12}>
        <Card
          title={trans("Requests Overview")}
          style={{
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
          bodyStyle={{ flex: 1, display: "flex", flexDirection: "column" }}
        >
          <BarChart data={barChartData} labels={barChartLabels} />
        </Card>
      </Col>
      <Col xs={24} lg={12}>
        <Card
          title={trans("Requests Distribution")}
          style={{
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
          bodyStyle={{ flex: 1, display: "flex", flexDirection: "column" }}
        >
          <div style={{ display: "flex", justifyContent: "center" }}>
            <PieChart
              data={pieChartData}
              labels={pieChartLabels}
              color={pieChartColors}
            />
          </div>
        </Card>
      </Col>
    </Row>
  );
}

